const localStorageEnum = {
    SAFT_ID_TOKEN: "SAFT_ID_TOKEN",
};

const getIdTokenFromStorage = () => {
    return localStorage.getItem(localStorageEnum.SAFT_ID_TOKEN) ?? null;
};

const isADevelopmentEnvironment = () => {
    return (
        window?.location?.hostname?.includes("localhost") ||
        window?.location?.hostname?.includes("dev") ||
        window?.location?.hostname?.includes("127.0.0.1") ||
        false
    );
};

export { getIdTokenFromStorage, localStorageEnum, isADevelopmentEnvironment };
